import { render } from "./ProductionStatus.vue?vue&type=template&id=35425ca4"
import script from "./ProductionStatus.vue?vue&type=script&lang=js"
export * from "./ProductionStatus.vue?vue&type=script&lang=js"

import exportComponent from "/builds/angeloferraro/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__